import React from 'react';
import {
  Box,
  Modal,
  ModalFooter,
  RichText,
  Stack,
  Text,
} from '@stitch-fix/mode-react';
import type {
  IncentiveBasicContentModule,
  RichText as RichTextType,
} from '../../../../types/definitions/vendor/graphql-schema.d';

const generateKey = (text: RichTextType) =>
  text?.plain?.toLowerCase().split(' ').join('');

export const TermsAndCondModal = ({
  closeModal,
  termsAndConditions,
}: {
  closeModal: () => void;
  termsAndConditions: IncentiveBasicContentModule[];
}) => {
  const modalFooter = (
    <Stack spacing={0.5} hAlign={{ sm: 'stretch', md: 'center' }}>
      <ModalFooter
        primaryAction={{
          variant: 'primary',
          text: 'Got it',
          onClick: closeModal,
        }}
      />
    </Stack>
  );

  return (
    <Modal
      isOpen
      onClose={closeModal}
      variant="slide-up-small"
      heading="Promo Terms & Conditions"
      footer={modalFooter}
    >
      <Stack spacing={2} pt={1.5}>
        {termsAndConditions?.map(
          ({ style, headline, body }: IncentiveBasicContentModule, idx) => {
            const renderListItems = (
              items: RichTextType[],
              listType: 'ol' | 'ul',
            ) => {
              return items.map(text => (
                <li
                  key={generateKey(text)}
                  style={{
                    display: 'list-item',
                    listStyleType: listType === 'ol' ? 'decimal' : 'disc',
                    marginBottom: '1rem',
                  }}
                >
                  <Text setting="body-medium">
                    <RichText>{String(text?.formatted)}</RichText>
                  </Text>
                </li>
              ));
            };

            return (
              <Box key={headline ? generateKey(headline) : idx} mb={2}>
                {headline?.formatted && (
                  <Text setting="body-medium" mb={0.5}>
                    <strong>
                      <RichText>{String(headline?.formatted)}</RichText>
                    </strong>
                  </Text>
                )}

                {style === 'PARAGRAPH' &&
                  body.map(text => (
                    <Text
                      setting="body-medium"
                      key={generateKey(text)}
                      mb={0.5}
                    >
                      <RichText>{String(text?.formatted)}</RichText>
                    </Text>
                  ))}

                {style === 'ORDERED_LIST' && (
                  <ol style={{ marginLeft: '1rem' }}>
                    {renderListItems(body, 'ol')}
                  </ol>
                )}

                {style === 'UNORDERED_LIST' && (
                  <ul style={{ marginLeft: '1rem' }}>
                    {renderListItems(body, 'ul')}
                  </ul>
                )}
              </Box>
            );
          },
        )}
      </Stack>
    </Modal>
  );
};
